import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Link from 'gatsby-link';
// Commenting Headroom as scroll transition is not required for top-bar anymore,
// but keeping it if anything changes.
// import Headroom from 'react-headroom';
import { toggleNavDrawer, toggleCartModal } from 'ducks/ui';
import { getTotalQuantity } from 'ducks/cart';
import { IconPlatform } from 'icons';
import { iconCartSvg, logoSvg, iconLogoSvg } from 'images';
import { CartDrawer, MainNav, IconLink } from 'components/shared';
import { theme, media } from 'styles';
import routes from 'helpers/routes';
import Button from '../Button';
import { Burger } from './components';

const Headroom = styled.div`
  width: 100%;
  position: fixed;
  top: 0px;
  display: block;
`;

const StyledTopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
  height: 60px;
  transition: all 0.5s;
  border-bottom: 1px solid ${theme.colors.border};
  background: ${theme.colors.white};

  ${media.ldesktop`
    height: 80px;
  `};
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  &:first-child {
    justify-content: flex-start;
  }

  &:last-child {
    justify-content: flex-end;
  }
`;

const SmallLogo = styled(Link)`
   {
    ${media.phablet`
      display: none;
    `};
  }
`;

const BigLogo = styled(Link)`
   {
    display: none;
    ${media.phablet`
      display: inline;
    `};
  }
`;

const Logo = styled.img`
  height: 28px;
  margin-right: 32px;
`;

const MainNavWrapper = styled.div`
  display: none;
  ${media.ldesktop`display: block;`};
`;

const IconLinks = styled.div`
  display: none;
  ${media.tablet`display: flex;`};
`;

const CartLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-left: 24px;
  cursor: pointer;
  height: 40px;
  color: ${theme.colors.navy};
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;

  &:first-child {
    margin-left: 0;
    border-left: 0;
    padding-left: 0;
  }

  display: flex;
  ${media.tablet`display: none`};

  img,
  svg {
    flex-shrink: 0;
    width: 24px;
  }
`;

const CartDrawerWrapper = styled.div`
  position: relative;
`;

const BookButton = styled(Button)`
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
`;

const propTypes = {
  isNavDrawerOpen: PropTypes.bool.isRequired,
  toggleNavDrawer: PropTypes.func.isRequired,
  toggleCartModal: PropTypes.func.isRequired,
  cartQuantity: PropTypes.number.isRequired,

  // Pass-through prop, we don't care what it is
  // eslint-disable-next-line react/forbid-prop-types
  productCategories: PropTypes.any.isRequired,
};

function TopBar(props) {
  return (
    <Headroom
      style={{
        position: 'fixed',
        transform: 'translateY(0%)',
        zIndex: theme.zIndices.TopBar,
      }}
    >
      <StyledTopBar>
        <Section>
          <Burger
            onClick={props.toggleNavDrawer}
            isOpen={props.isNavDrawerOpen}
          />
          <SmallLogo to="/">
            <Logo full src={iconLogoSvg} alt="MarketTap" />
          </SmallLogo>
          <BigLogo to="/">
            <Logo full src={logoSvg} alt="MarketTap" />
          </BigLogo>

          <MainNavWrapper>
            <MainNav productCategories={props.productCategories} />
          </MainNavWrapper>
        </Section>

        <Section>
          <IconLinks>
            <BookButton to={routes.bookMarketer.index} small>
              Book A Call
            </BookButton>
            <IconLink
              external
              href={`${process.env.GATSBY_MARKETTAP_PLATFORM_CLIENT_HOST}`}
            >
              <IconPlatform />
              My Account
            </IconLink>

            <IconLink onClick={props.toggleCartModal}>
              <img src={iconCartSvg} alt="Cart" />
              Cart ({props.cartQuantity})
            </IconLink>
          </IconLinks>
          <CartLink onClick={props.toggleCartModal}>
            <img src={iconCartSvg} alt="Cart" />
            Cart ({props.cartQuantity})
          </CartLink>
          <CartDrawerWrapper>
            <CartDrawer />
          </CartDrawerWrapper>
        </Section>
      </StyledTopBar>
    </Headroom>
  );
}

TopBar.propTypes = propTypes;

const mapStateToProps = state => ({
  isNavDrawerOpen: state.ui.isNavDrawerOpen,
  cartQuantity: getTotalQuantity(state),
});

const mapDispatchToProps = { toggleNavDrawer, toggleCartModal };

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/components/shared/TopBar/TopBar.jsx